import React from 'react';
import { IconProps } from '.';

const SvgColoredRobot = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#D9D9D9'
        d='M12.828 5.484h-1.656V7H6a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4v-8a4 4 0 0 0-4-4h-5.172V5.484Z'
      />
      <path
        fill='#000'
        fillOpacity={0.5}
        fillRule='evenodd'
        d='M22 17v-4a2 2 0 1 1 0 4ZM2 13v4a2 2 0 1 1 0-4Z'
        clipRule='evenodd'
      />
      <path
        fill='#AE5353'
        d='M7.426 17.93c.028.11.714 2.676 4.574 2.676 3.861 0 4.547-2.566 4.575-2.676a.305.305 0 0 0-.145-.338.309.309 0 0 0-.367.047c-.011.011-1.194 1.134-4.063 1.134-2.868 0-4.051-1.123-4.062-1.134a.306.306 0 0 0-.512.291Z'
      />
      <circle cx={8} cy={13} r={3} fill='#fff' />
      <circle cx={8} cy={13} r={2} fill='#131313' />
      <circle cx={16} cy={13} r={3} fill='#fff' />
      <circle cx={16} cy={13} r={2} fill='#131313' />
      <circle cx={12} cy={3.483} r={2.483} fill='#F05046' />
    </svg>
  );
};

export default SvgColoredRobot;
